// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__6GnaJ","modal":"Modal_modal__yEgVW","modalCloseBtn":"Modal_modalCloseBtn__O2jDt","modalContent":"Modal_modalContent__JODE3"};